module.exports = __webpack_public_path__ + "static/header-image@2x-8ec35acada5b5bf914c8ba745aee3db1.webp";